import nrLogger from '../nrLogger'

const mfeErrorLog = (error: Error, info: { componentStack: string }) => {
  console.error('MFE error:', error, info)
  nrLogger.error('mfeErrorLog', error)
}

export default mfeErrorLog
